import React from "react";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useDispatch } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";

const UsersWorkspaceCreate = () => {
  const dispatch = useDispatch();

  return (
    <div className="user_admin__create__workspace">
      <span>Create User</span>
      <Button
        onClick={() => {
          dispatch(showModal(modalTypes.NEW_USER));
        }}
        variant={buttonVariants.primary}
        content={<span>Create User...</span>}
      />
      <Button
        onClick={() => {
          dispatch(showModal(modalTypes.IMPORT_USERS));
        }}
        variant={buttonVariants.secondary}
        content={<span>Import from CSV</span>}
      />
    </div>
  );
};

export default UsersWorkspaceCreate;
